/* eslint-disable react/jsx-props-no-spreading */
import { StandardTextFieldProps, TextField as InMarKitTextField } from '@mui/material';
import React from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { NumericFormat, NumericFormatProps } from 'react-number-format';

type NumericTextFieldProps = {
  normalizeOutput?: Function;
  normalizeInput?: Function;
  name: string;
  rules?: any;
} & NumericFormatProps<StandardTextFieldProps>;

function NumericTextField({
  name,
  rules,
  normalizeOutput = (event) => event,
  normalizeInput = (input) => input,
  ...rest
}: NumericTextFieldProps) {
  const { control, register } = useFormContext();
  const { ref } = register(name, rules);
  const { field, fieldState } = useController({ control, name });

  return (
    <NumericFormat
      name={name}
      variant="standard"
      size="small"
      getInputRef={ref}
      value={normalizeInput(field.value) || ''}
      onChange={(event) => field.onChange(normalizeOutput(event))}
      onBlur={field.onBlur}
      customInput={InMarKitTextField}
      error={!!fieldState.error}
      helperText={fieldState.error?.message}
      {...rest}
    />
  );
}

export default NumericTextField;
